import { CheckmarkSolidIcon } from '../../Icons';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { resolveIconFontSize } from './listBoxDefaultStyle';
import { Box } from '../../Box';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styledItem = () => ({
  display: 'flex',
  gap: '8px',
  wordWrap: 'break-word',
  whiteSpace: 'pre-wrap',
  width: '100%',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
});
export const ListBoxItemContent = props => {
  const {
    content,
    size,
    selected,
    className
  } = props;
  const theme = useInterstateTheme();
  const fontSize = resolveIconFontSize(size, theme);
  return /*#__PURE__*/_jsxs(Box, {
    sx: styledItem(),
    className: className,
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        visibility: selected ? 'visible' : 'hidden'
      },
      children: /*#__PURE__*/_jsx(CheckmarkSolidIcon, {
        fontSize: fontSize,
        color: theme.tokens.ComponentListBoxItemSelectedIconColor
      })
    }), content]
  });
};